//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { CreatorsCampaignsTrackingIds } from '@campaigns/components/campaign-requests/creator-campaigns/CreatorsCampaignsTrackingId';
import { ProfileNetwork } from '@influencers/constants/influencersConstants';
import { SocialNetwork } from '@models/SocialNetwork';
import { TrackingId } from '@models/TrackingId';

export interface NetworkOption {
  value: ProfileNetwork;
  label: string;
  trackingId: TrackingId;
}

export const NETWORK_OPTIONS: NetworkOption[] = [
  {
    value: SocialNetwork.Instagram,
    label: 'Instagram',
    trackingId:
      CreatorsCampaignsTrackingIds.UPLOAD_CREATOR_CAMPAIGN_MEDIA_NETWORK_INSTAGRAM,
  },
  {
    value: SocialNetwork.YouTube,
    label: 'YouTube',
    trackingId:
      CreatorsCampaignsTrackingIds.UPLOAD_CREATOR_CAMPAIGN_MEDIA_NETWORK_YOUTUBE,
  },
  {
    value: SocialNetwork.TikTok,
    label: 'TikTok',
    trackingId:
      CreatorsCampaignsTrackingIds.UPLOAD_CREATOR_CAMPAIGN_MEDIA_NETWORK_TIKTOK,
  },
];

export const SUPPORTED_FORMATS: Record<ProfileNetwork, string> = {
  [SocialNetwork.Instagram]:
    'Supported formats: www.instagram.com/p/mediaCode, www.instagram.com/reel/mediaCode, www.instagram.com/tv/mediaCode',
  [SocialNetwork.YouTube]:
    'Supported formats: www.youtube.com/watch?v=videoId, youtu.be/videoId, www.youtube.com/shorts/videoId',
  [SocialNetwork.TikTok]:
    'Supported formats: www.tiktok.com/@username/video/videoId',
};
